import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';
import { BonCommandeFormComponent } from './bonCommande-form/bonCommande-form.component';
import { DetailBonCommandeComponent } from './detail-bonCommande/detail-bonCommande.component';
import { BonCommandeModalAjoutFormComponent } from './modal/user-modal-ajout-form/bonCommande-modal-ajout-form.component';
import { ListBonCommandeComponent } from './list-bonCommande/list-bonCommande.component';

@NgModule({
	declarations: [
		DetailBonCommandeComponent,
		BonCommandeFormComponent,
		ListBonCommandeComponent,
		BonCommandeModalAjoutFormComponent
	],
	imports: [SharedModule, GestionDonneesModule]
})
export class BonCommandeModule {}
